export default "__VITE_ASSET__3cdfc545__"